import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { MatchState } from "../store/constants";
import { MatchLeague, TeamOfTheWeekLineup } from "../client/api";

export const selectMatchSlice = (s: RootState): MatchState => s.match;

export const selectMatchStatus = createSelector(
  selectMatchSlice,
  (m) => m.status
);

export const selectMatchDays = createSelector(
  selectMatchSlice,
  (m) => m.matchDays
);


export const makeSelectTotwByLeagueAndDay = (
  leagueId: number | string,
  matchDay: number
) =>
  createSelector(
    selectMatchSlice,
    (m: MatchState): (TeamOfTheWeekLineup | null) | undefined => {
      const list = m.totw ?? [];
      return list.find(
        (v) => String(v.id) === String(leagueId) && v.date === matchDay
      )?.response;
    }
  );

export const makeSelectFullMatchById =
  (matchId: number | string) =>
    (s: RootState): MatchLeague | undefined =>
      s.match.matches.find((m) => String(m.id) === String(matchId));
